/**
 * 添加
 */
const setStorage = function (key, value, type = 'local') {
  if (value instanceof Object) {
    value = JSON.stringify(value)
  }
  if (type === 'session') {
    sessionStorage.setItem(key, value)
  } else {
    localStorage.setItem(key, value)
  }
}
/**
 * 取值
 */
const getStorage = function (name, type = 'local') {
  let info = type === 'session' ? sessionStorage.getItem(name) : localStorage.getItem(name)
  try {
    return JSON.parse(info)
  } catch (e) {
    return info
  }
}
/**
 * 删除
 * @param  {String}
 */
const removeStorage = function (key, type = 'local') {
  if (type === 'session') {
    sessionStorage.removeItem(key)
  } else {
    localStorage.removeItem(key)
  }
}
/**
 * 清除所有
 */
const clearAll = function () {
  // 招生老师端责任人缓存
  const assessorList = getStorage('assessorList')
  // sessionStorage.clear()
  localStorage.clear()
  if (assessorList) setStorage('assessorList', assessorList)
}
var storage = {
  set: setStorage,
  get: getStorage,
  remove: removeStorage,
  clearAll: clearAll
}
// 对外提供接口
export default storage



// WEBPACK FOOTER //
// ./src/utils/storage/storage.js